import m from "../../geodata/es2015/americanSamoaLow";
window.am4geodata_americanSamoaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/americanSamoaLow.js
// module id = null
// module chunks = 